<template>
    <b-container fluid>
        <b-modal id="bv-modal-settings-save-error" hide-footer>
            <h3 class="text-center">{{$t('saved_error')}}</h3>
            <b-button block variant="danger" @click="$bvModal.hide('bv-modal-settings-save-error')">Ок</b-button>
        </b-modal>
        <b-alert v-model="showSuccessAlert" variant="success" dismissible>{{$t('saved_successful')}}</b-alert>
        <b-form @submit.prevent="onSubmit">
            <fieldset :disabled="isBusy">
                <b-form-group label-for="name" :label="$t('device_configuration_list.coll.header.name')">
                    <b-form-input id="name" v-model="deviceInfo.name" />
                </b-form-group>
                <b-form-group label-for="description" :label="$t('device_configuration_list.coll.header.description')">
                    <b-form-input id="description" v-model="deviceInfo.description" />
                </b-form-group>
                <b-form-group label-for="isActive" :label="$t('device_configuration_list.coll.header.isActive')">
                    <b-form-checkbox id="isActive" v-model="deviceInfo.isActive" />
                </b-form-group>
                <div v-if="!validMetadata()" class="text-danger template-metadata-limits">{{$t('template_metadata_limits')}}</div>
                <b-button :disabled="!validMetadata() || isBusy" type="submit" variant="primary">{{$t('save')}}</b-button>
            </fieldset>
        </b-form>
    </b-container>
</template>
<script>
import axios from 'axios';
import { isText, isRouteId } from '../../utils/FormValidation';
import { RequestGuard } from '../../utils/RequestGuard';

export default {
    name: 'SavedTemplatePassport',
    props: ['id', 'isDefault', 'isActive', 'description', 'name'],
    data() { return { deviceInfo: {}, showSuccessAlert: false, isBusy: false, disposed: false, guard: new RequestGuard() }; },
    methods: {
        validMetadata() {
            return !this.disposed && isRouteId(Number(this.id)) && isText(this.deviceInfo.name, 1, 50)
                && (this.deviceInfo.description === null || typeof this.deviceInfo.description === 'string' && Array.from(this.deviceInfo.description).length <= 250)
                && typeof this.deviceInfo.isActive === 'boolean';
        },
        initMetadata() {
            this.guard.invalidate(); this.isBusy = false; this.showSuccessAlert = false;
            this.deviceInfo = { name: this.name, description: this.description, isActive: this.isActive };
        },
        async onSubmit() {
            if (!this.validMetadata() || this.isBusy) return;
            const request = this.guard.begin();
            if (request === null) return;
            this.isBusy = true; this.showSuccessAlert = false;
            const data = { name: this.deviceInfo.name, description: this.deviceInfo.description ?? '', isActive: this.deviceInfo.isActive };
            try {
                const response = await axios.post('api/v1/saved-configurations/' + this.id, data, {
                    ...this.guard.config(request), headers: { 'Content-type': 'application/json' },
                });
                if (!this.guard.isCurrent(request)) return;
                if (!isRouteId(response.data?.id)) throw new Error('Invalid metadata response');
                this.showSuccessAlert = true;
            } catch (error) {
                if (this.guard.isCurrent(request) && error.response?.status !== 401) this.$bvModal.show('bv-modal-settings-save-error');
            } finally {
                if (this.guard.isCurrent(request)) { this.isBusy = false; this.guard.finish(request); }
            }
        },
    },
    mounted() { this.initMetadata(); },
    watch: { id() { this.initMetadata(); } },
    beforeDestroy() { this.disposed = true; this.guard.invalidate(); },
};
</script>
